// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './routes/routes'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookie'
import i18n from './i18n'
import {store} from './store'

import bigInt from 'big-integer'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'
import './assets/common.css'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import MaskedInput from 'vue-masked-input'

import modalOkCancel from '@/components/modals/modalOkCancel.vue'
import BasicTable from '@/components/tables/BasicTable.vue'
import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'
import TableManagerBottomSmall from '@/components/tables/TableManagerBottomSmall'
import TableManagerSearch from '@/components/tables/TableManagerSearch'
import ReportHeader from '@/components/tables/ReportHeader'
import TelephonyOperatorsReportHeader from '@/components/tables/TelephonyOperatorsReportHeader'
import jqueryDataPicker from '@/components/datePicker'
import flatPickr from '@/components/flatPicker.vue'

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import vClickOutside from 'v-click-outside'
import VueMaterial from 'vue-material'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLineCharts from '@/pages/layout/lineChart'
import VueDoughnutCharts from '@/pages/layout/doughnutChart'
import VueBarCharts from '@/pages/layout/barChart'

import api from '@/utils/api.js'

Vue.use(VueMaterial)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(bigInt)
Vue.use(VueMoment, { moment })
Vue.use(VueCookie)
Vue.use(api)
Vue.use(require('vue-chartist'))
Vue.use(VueSidebarMenu)
Vue.use(vClickOutside)

Vue.component('masked-input', MaskedInput)
Vue.component('modal-ok-cancel', modalOkCancel)
Vue.component('basic-table', BasicTable)
Vue.component('table-manager', TableManager)
Vue.component('table-manager-search', TableManagerSearch)
Vue.component('table-manager-bottom', TableManagerBottom)
Vue.component('table-manager-bottom-small', TableManagerBottomSmall)
Vue.component('chartline-component', VueLineCharts)
Vue.component('chartdoughnut-component', VueDoughnutCharts)
Vue.component('chartbar-component', VueBarCharts)
Vue.component('data-picker', jqueryDataPicker)
Vue.component('report-header', ReportHeader)
Vue.component('telephony-operators-report-header', TelephonyOperatorsReportHeader)
Vue.component('flat-picker', flatPickr)

export const cookie = VueCookie
export const router = new VueRouter({
  routes,
  linkExactActiveClass: 'nav-item active'
})

/* eslint-disable no-new */
export const vue = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  api,
  store,
  i18n,
  mixins: [{
    methods: {
      showDataWithTZDelta: function (intDate) {
        let delta = Number(localStorage.getItem('tzDelta'))
        return moment((Number(intDate) + delta) * 1000).format('DD-MM-YYYY HH:mm:ss')
      },
      getMomentWithTZDelta: function (intDate) {
        let delta = Number(localStorage.getItem('tzDelta'))
        return moment((Number(intDate) + delta) * 1000)
      },
      getMomentWithOutTZDelta: function (intDate) {
        let delta = Number(localStorage.getItem('tzDelta'))
        return moment((Number(intDate) - delta) * 1000)
      },
      setDataWithSelectedTZ: function () {
        return moment().utcOffset(Number(localStorage.getItem('gmt_offset_min')))
      }
    }
  }]
})



// WEBPACK FOOTER //
// ./src/main.js